export const validatePassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const requirements = [
    {
      id: 'length',
      message: `At least ${minLength} characters long`,
      isMet: password.length >= minLength
    },
    {
      id: 'uppercase',
      message: 'Contains at least one uppercase letter',
      isMet: hasUpperCase
    },
    {
      id: 'lowercase',
      message: 'Contains at least one lowercase letter',
      isMet: hasLowerCase
    },
    {
      id: 'number',
      message: 'Contains at least one number',
      isMet: hasNumbers
    },
    {
      id: 'special',
      message: 'Contains at least one special character',
      isMet: hasSpecialChar
    }
  ];

  const strength = requirements.filter(req => req.isMet).length;
  let strengthText = '';
  let strengthColor = '';

  switch (strength) {
    case 0:
    case 1:
      strengthText = 'Very Weak';
      strengthColor = 'red.500';
      break;
    case 2:
      strengthText = 'Weak';
      strengthColor = 'orange.500';
      break;
    case 3:
      strengthText = 'Medium';
      strengthColor = 'yellow.500';
      break;
    case 4:
      strengthText = 'Strong';
      strengthColor = 'green.500';
      break;
    case 5:
      strengthText = 'Very Strong';
      strengthColor = 'green.600';
      break;
    default:
      strengthText = 'Very Weak';
      strengthColor = 'red.500';
  }

  return {
    isValid: strength >= 4, // Require at least "Strong" password
    strength,
    strengthText,
    strengthColor,
    requirements,
    hasUpperCase,
    hasLowerCase,
    hasNumbers,
    hasSpecialChar,
    isLongEnough: password.length >= minLength
  };
};
